import type { ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './choice-card.module.scss';

export type ChoiceCardProps = {
  name: string;
  value: string;
  checked: boolean;
  onSelect: (value: string) => void;
  title: string;
  description?: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  compact?: boolean;
  /** Fires on every click, also on an already checked card (a radio only reports changes). */
  onClick?: (() => void) | undefined;
  className?: string | undefined;
};

/** Radio option rendered as a card (delivery and payment methods). */
export function ChoiceCard({
  name,
  value,
  checked,
  onSelect,
  title,
  description,
  icon,
  disabled = false,
  compact = false,
  onClick,
  className,
}: ChoiceCardProps) {
  return (
    <label
      className={cx(styles.root, className)}
      data-checked={checked || undefined}
      data-disabled={disabled || undefined}
      data-compact={compact || undefined}
    >
      <input
        className={styles.input}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onSelect(value)}
        onClick={onClick ? () => onClick() : undefined}
      />
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <span className={styles.title}>{title}</span>
      {description && <span className={styles.description}>{description}</span>}
    </label>
  );
}
